import React, { useState } from 'react';
import { useCookies } from 'react-cookie';
import CalendarComponent from './CalendarComponent';
import { useNavigate } from 'react-router-dom';

const Calendar = ({
    api,
    currentDate,
    setCurrentDate,
    // date : [user]
    currentMonthBirthdays }) => {

    const CakeEmoji = "\u{1F382}"

    const navigate = useNavigate()
    const [cookies] = useCookies()
    const [selectedDate, setSelectedDate] = useState(null);
    const [name, setName] = useState("");
    // state for add custom birthday popup
    const [open, setOpen] = useState(false);
    // state for birthdays on current day popup
    const [birthdaysPopupOpen, setBirthdaysPopupOpen] = useState(false);
    const [selectedBirthdays, setSelectedBirthdays] = useState([])

    const today = new Date()

    // Get the days of the current month
    const getDaysInMonth = (date) => {
        const endOfMonth = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        const days = [];

        for (let i = 1; i <= endOfMonth.getDate(); i++) {
            days.push({
                date: new Date(date.getFullYear(), date.getMonth(), i),
                birthdays: currentMonthBirthdays[i] ? CakeEmoji : ""
            }
            );
        }

        return days;
    };

    // Function to go to the next month
    const nextMonth = () => {
        setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() + 1));
    };

    // Function to go to the previous month
    const prevMonth = () => {
        setCurrentDate(new Date(currentDate.getFullYear(), currentDate.getMonth() - 1));
    };

    const startOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth(), 1);

    const firstDayOfWeek = startOfMonth.getDay();


    // Get all the days of the current month
    const daysInMonth = getDaysInMonth(currentDate);
    const emptyDays = Array.from({ length: firstDayOfWeek }, (_, i) => i);


    // Get the name of the current month
    const monthName = currentDate.toLocaleString('default', { month: 'long' });

    // Get the current year
    const year = currentDate.getFullYear();

    const handleDateClick = (date) => {
        const birthdays = currentMonthBirthdays[date]
        if (birthdays) {
            setSelectedBirthdays(birthdays)
            setBirthdaysPopupOpen(true)
        } else {
            setOpen(true);
        }

        setSelectedDate(date);

    };

    const handleAddNewBirthday = () => {
        setBirthdaysPopupOpen(false);
        setOpen(true);
    };


    const handleClose = (e) => {
        setOpen(false);
        setBirthdaysPopupOpen(false)
    };

    const handleBirthdayClick = (birthday) => {
        if (birthday.other && birthday.other.username) {
            navigate(`/user/${birthday.other.username}`)
        }

    }

    const handleSave = async () => {
        if (!name.trim()) return;
        try {

            const resp = await api().createCustomBirthday(cookies.token, {
                month: currentDate.getMonth() + 1,
                day: selectedDate,
                label: name
            })
            if (resp.status === 200) {
                setOpen(false)
                window.location.reload();
            }
        } catch (error) {
            console.error("Failed to save birthday", error);
        }
    };

    return (
        <div>
            <CalendarComponent
                monthName={monthName}
                year={year}
                prevMonth={prevMonth}
                nextMonth={nextMonth}
                emptyDays={emptyDays}
                daysInMonth={daysInMonth}
                today={today}
                handleDateClick={handleDateClick}
            />

            {open && (
                <div
                    id="modal-overlay"
                    className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50"
                    onClick={handleClose}
                >
                    <div className="bg-white p-4 rounded shadow-md text-black relative  min-w-[350px] max-w-md" onClick={(e) => e.stopPropagation()}>
                        <button
                            className="absolute top-2 right-2 text-xl font-bold text-gray-700 hover:text-black"
                            onClick={() => setOpen(false)}
                        >
                            ×
                        </button>
                        <h2 className="text-lg font-bold">{`Add a birthday on ${currentDate.getMonth() + 1}/${selectedDate}`}</h2>
                        <p>Enter their name:</p>
                        <input
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            placeholder="Name"
                            className="border p-2 w-full mt-2"
                        />
                        <button onClick={handleSave} className="mt-4 bg-blue-500 w-full text-white p-2 rounded block mx-auto">
                            Save
                        </button>
                    </div>
                </div>
            )}

            {birthdaysPopupOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-gray-500 bg-opacity-50" onClick={handleClose}>
                    <div className="bg-white p-4 rounded shadow-md text-black relative  min-w-[350px] max-w-md" onClick={(e) => e.stopPropagation()}>
                        <button className="absolute top-2 right-2 text-xl font-bold text-gray-700 hover:text-black" onClick={handleClose}>
                            ×
                        </button>
                        <h2 className="text-lg font-bold">{`Birthdays on ${currentDate.getMonth() + 1}/${selectedDate}`}</h2>
                        <ul className="mt-2">
                            {selectedBirthdays.map((birthday, index) => (
                                <li key={index} className="text-gray-800">
                                {birthday.other ? (
                                    <button 
                                        onClick={() => handleBirthdayClick(birthday)} 
                                        className="text-blue-600 hover:underline"
                                    >
                                        {birthday.name}
                                    </button>
                                ) : (
                                    birthday.name
                                )}
                            </li>
                            ))}
                        </ul>
                        <button onClick={handleAddNewBirthday} className="mt-4 bg-blue-500 w-full text-white p-2 rounded">
                            Add New Birthday
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default Calendar;

